// extracted by css-extract-rspack-plugin
export default {"emboldened":"ContentfulRiver-module__emboldened__n1Wr6"};